import router from '@/router'
import Cookies from "js-cookie";
import {MessageBox} from "element-ui";
import {removeToken} from "@/utils/auth";
import i18n from "@/lang";

function findAllValues(root) {
    let values = [];
    function dfs(node) {
        if (node !== null) {
            values.push(node.path);
            if (node.children) {
                for (let child of node.children) {
                    dfs(child);
                }
            }
        }
    }

    dfs(root);

    return values;
}

router.beforeEach(async (to, from, next) => {
    // 获取所有路由path组成的数组
    let paths = findAllValues({
        path: "/",
        children: router.options.routes
    });

    // 1. 处理需要登录的路由
    if (to.meta.requiresAuth) {
        // 检查是否有token
        if (Cookies.get('token')) {
            // 目标路由不在路由表中 -> 404
            if (!paths.includes(to.path)) {
                next('/404');
                return; // 关键：终止后续逻辑
            }
            // 根路径重定向到首页
            else if(to.path === '/') {
                next('/homePages')
                return;
            }
            // 正常路由放行
            else {
                next();
                return;
            }
        }
        // 无token的情况
        else {
            // 特殊处理：允许无token访问首页（根据业务调整）
            if (to.path === '/homePages') {
                next();
                return;
            }
            // 其他路由需要登录
            else {
                try {
                    // 等待用户确认
                    await MessageBox.confirm(
                        i18n.t('login.expiredMessage'),
                        i18n.t('login.expiredTitle'),
                        {
                            confirmButtonText: i18n.t('userInfo.messages.confirm'),
                            cancelButtonText: i18n.t('userInfo.messages.cancel'),
                            type: 'warning',
                        }
                    );
                    // 用户点击确定：跳转到登录页
                    removeToken();
                    next('/login');
                } catch (error) {
                    // 用户点击取消：阻止跳转
                    next(false);
                }
                return; // 终止后续逻辑，避免执行末尾的next()
            }
        }
    } else {
        if(to.path === '/') {
            next('/homePages')
            return;
        } else {
            next();
        }
        return;
    }

    // 3. 根路径重定向（已在上面的逻辑中处理，可简化）
    // 注意：如果上面的逻辑都有return，这里不会执行
    if (to.path.length <= 1) {
        next('/homePages');
    } else {
        next();
    }
});

router.afterEach(() => {
    // finish progress bar
    // NProgress.done()
})
